module.exports = __webpack_public_path__ + "static/media/tds.6608cea1.png";